/**
 * MOBILE PERFORMANCE MODULE
 * Optimized for mobile-first customers, focusing on touch interactions and smooth scrolling.
 */

(function() {
  'use strict';

  class MobilePerformance {
    constructor() {
      // Run only on mobile devices
      if (window.innerWidth > 768) return;

      this.init();
    }

    init() {
      this.optimizeScrolling();
      this.setupTouchOptimizations();
      this.setupMobileImageLoading();
    }

    // Efficient scrolling for mobile
    optimizeScrolling() {
      let isScrolling = false;
      let scrollTimeout;

      const handleScroll = () => {
        if (!isScrolling) {
          requestAnimationFrame(() => {
            document.body.classList.add('is-scrolling');
            isScrolling = false;
          });
          isScrolling = true;
        }

        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(() => {
          document.body.classList.remove('is-scrolling');
        }, 150);
      };

      window.addEventListener('scroll', handleScroll, { passive: true });
    }

    // Touch optimizations for a native-like feel
    setupTouchOptimizations() {
      const touchElements = document.querySelectorAll('button, a, [role="button"]');

      touchElements.forEach(element => {
        element.addEventListener('touchstart', () => {
          element.classList.add('touching');
        }, { passive: true });

        const removeTouchingClass = () => element.classList.remove('touching');
        element.addEventListener('touchend', removeTouchingClass, { passive: true });
        element.addEventListener('touchcancel', removeTouchingClass, { passive: true });
      });

      this.setupCarouselSwipe();
    }

    // Lazy load images on mobile
    setupMobileImageLoading() {
      const images = document.querySelectorAll('img[data-src-mobile]');

      if ('IntersectionObserver' in window) {
        const imageObserver = new IntersectionObserver((entries, observer) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              const img = entry.target;
              img.src = img.dataset.srcMobile;
              img.removeAttribute('data-src-mobile');
              observer.unobserve(img);
            }
          });
        }, { rootMargin: '50px 0px' });

        images.forEach(img => imageObserver.observe(img));
      } else {
        // Fallback for older browsers
        images.forEach(img => {
          img.src = img.dataset.srcMobile;
          img.removeAttribute('data-src-mobile');
        });
      }
    }

    // Swipe gestures for carousels
    setupCarouselSwipe() {
      const carousels = document.querySelectorAll('.js-carousel');

      carousels.forEach(carousel => {
        let startX, startY;

        carousel.addEventListener('touchstart', (e) => {
          startX = e.touches[0].clientX;
          startY = e.touches[0].clientY;
        }, { passive: true });

        carousel.addEventListener('touchend', (e) => {
          if (!startX || !startY) return;

          const endX = e.changedTouches[0].clientX;
          const endY = e.changedTouches[0].clientY;
          const diffX = startX - endX;
          const diffY = startY - endY;

          if (Math.abs(diffX) > Math.abs(diffY) && Math.abs(diffX) > 30) {
            if (diffX > 0) {
              carousel.querySelector('.js-carousel-next')?.click();
            } else {
              carousel.querySelector('.js-carousel-prev')?.click();
            }
          }
          startX = startY = null;
        }, { passive: true });
      });
    }
  }

  // Initialize when the DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => new MobilePerformance());
  } else {
    new MobilePerformance();
  }

})(); 